import { $qs, $qsa } from "./utils/QuerySelector";
import gsap from "gsap";
import Lenis from "lenis";
import ScrollTrigger from "gsap/ScrollTrigger";
import tailwindConfig from "../../tailwind.config";

const screenLG = tailwindConfig.theme.screens.lg.replace("px", "");
const screenMD = tailwindConfig.theme.screens.md.replace("px", "");
const screenSM = tailwindConfig.theme.screens.sm.replace("px", "");

gsap.registerPlugin(ScrollTrigger);
let lenis = null;
function smoothScrolling() {
	lenis = new Lenis({
		duration: 1.2,
		easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // https://www.desmos.com/calculator/brs54l4xou
		direction: "vertical", // vertical, horizontal
		gestureDirection: "vertical", // vertical, horizontal, both
		smooth: true,
		mouseMultiplier: 0.5,
		smoothTouch: false,
		touchMultiplier: 2,
		infinite: false,
	});

	lenis.on("scroll", () => {
		ScrollTrigger.update();
	});

	gsap.ticker.add((time) => {
		lenis.raf(time * 1000);
	});

	gsap.ticker.lagSmoothing(0);
}
/**
 * Open PDFs in new window
 */
function linksCustomization() {
	var pdfLinks = document.querySelectorAll(
		'a[href$=".pdf"], .menu-item-type-custom > a'
	);

	pdfLinks.forEach((pdf) => {
		pdf.setAttribute("target", "_blank");
	});
}

/**
 * Adds smooth scrolling to anchor links
 *
 * Adds data-scroll-to attribute to anchor links without it.
 */
function scrollTo() {
	// Function to handle smooth scrolling for anchor links
	function smoothScroll(target, offset) {
		//console.info(target.offsetTop);
		if (target && target == "#contactForm" && window.innerWidth > screenLG) {
			lenis.scrollTo(window.innerHeight, { duration: 2, lock: true });
		} else if (target) {
			lenis.scrollTo($qs(target).offsetTop - offset, {
				duration: 2,
				lock: true,
			});
		}
	}

	// Detect all anchor links on the page without data-scroll-to attribute
	// const scrollToLinks = document.querySelectorAll(
	// 	'a[href^="#"]:not([data-scroll]):not([class^="magnific-"]:not([data-popup])'
	// );
	// scrollToLinks.forEach((link) => {
	// 	link.setAttribute("data-scroll", "scroll-to");
	// });

	// Event listener for anchor links
	let anchorLinks = document.querySelectorAll("[data-scroll-to]");

	anchorLinks.forEach((element) => {
		element.addEventListener("click", function (event) {
			const target = element;
			//console.info(target.getAttribute("href"));
			//console.info("scrollto");

			event.preventDefault(); // Prevent default anchor link behavior

			let offset = 50; // Adjust this value to set the desired offset
			if (target.getAttribute("data-scroll-space")) {
				if (target.getAttribute("data-scroll-space") == "half") {
					offset = window.innerHeight / 2 - 100;
				} else {
					offset = target.getAttribute("data-scroll-space");
				}
			}
			smoothScroll(target.getAttribute("href"), offset); // Smooth scroll to the target element with an offset
		});
	});
}

/**
 * Adds a class to tablepress tables to make them responsive.
 */
function responsiveTables() {
	/* if ( document.querySelectorAll('.tablepress').length > 0 ) {
		const tables = document.querySelectorAll('.tablepress');

		var wrap = function (toWrap, wrapper) {
			wrapper = wrapper || document.createElement('div');
			wrapper.classList.add('responsive-table');
			toWrap.parentNode.appendChild(wrapper);
			return wrapper.appendChild(toWrap);
		};

		[...tables].forEach((table) => {
			wrap(table);
		});
	} */
	if (document.querySelectorAll(".prose table").length > 0) {
		const tables = document.querySelectorAll(".prose table");

		var wrap = function (toWrap, wrapper) {
			wrapper = wrapper || document.createElement("div");
			wrapper.classList.add("responsive-table");

			// Insert the wrapper before the toWrap element
			toWrap.parentNode.insertBefore(wrapper, toWrap);

			return wrapper.appendChild(toWrap);
		};

		[...tables].forEach((table) => {
			wrap(table);
		});
	}
}

function notificationPopup() {
	//console.info("notificationPopup");
	//console.info("document loaded");
	const notificationPopup = $qs('[data-name="notification-popup"]');
	if (!notificationPopup) return;

	const closePopup = $qs('[data-name="close-button"]', notificationPopup);
	const notificationLinks = $qsa("a", notificationPopup);

	let cookieName = phpVars["cookieName"]; // controls whether we need to show the notification popup or not.
	let popupNotificationCookieName = getCookie(cookieName); // Checks if the message was already displayed and closed.
	let twkCookiesEssential = getCookie("twk_cookies_essential"); // Checks if the user accepted "Essential" cookies.
	twkCookiesEssential = true;
	let popupExpiryTime = phpVars["popupExpiryTime"];

	if (!popupNotificationCookieName) {
		gsap.to(notificationPopup, { autoAlpha: 1 });

		// Close popup.
		closePopup.addEventListener("click", function (event) {
			event.preventDefault();

			if (twkCookiesEssential) setCookie(cookieName, "true", popupExpiryTime); // Once its shown, it won't show up again until the cookie expires.

			gsap.to(notificationPopup, { autoAlpha: 0, y: "100px" });
		});

		// Accepts the popup cookie and go to link. (Closes the notification popup but going to the link).
		if (notificationLinks.length > 0) {
			notificationLinks.forEach((item) => {
				item.addEventListener("click", function (event) {
					event.preventDefault();

					if (twkCookiesEssential)
						setCookie(cookieName, "true", popupExpiryTime);

					window.location = $(this).attr("href");
				});
			});
		}
	}
}

function getCookie(name) {
	var dc = document.cookie;
	var prefix = name + "=";
	var begin = dc.indexOf("; " + prefix);
	if (begin == -1) {
		begin = dc.indexOf(prefix);
		if (begin != 0) return null;
	} else {
		begin += 2;
		var end = document.cookie.indexOf(";", begin);
		if (end == -1) {
			end = dc.length;
		}
	}
	// because unescape has been deprecated, replaced with decodeURI
	//return unescape(dc.substring(begin + prefix.length, end));
	return decodeURI(dc.substring(begin + prefix.length, end));
}
function setCookie(cname, cvalue, exdays) {
	var d = new Date();
	d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
	var expires = "expires=" + d.toUTCString();

	if (exdays == 0) {
		document.cookie = cname + "=" + cvalue + ";path=/";
	} else {
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}
}


function textEditorDetectIframesTogether(){
	const iframes = document.querySelectorAll('.prose iframe[src*="youtube"]');
    
    for (let i = 0; i < iframes.length - 1; i++) {
        const currentIframe = iframes[i];
        const nextIframe = iframes[i + 1];
        
        const currentP = currentIframe.closest('p');
        const nextP = nextIframe.closest('p');

        if (nextP && currentP.nextElementSibling === nextP) {
            const wrapperDiv = document.createElement('div');
            wrapperDiv.classList.add('iframe-pair');

            currentP.parentNode.insertBefore(wrapperDiv, currentP);

            wrapperDiv.appendChild(currentP);
            wrapperDiv.appendChild(nextP);

            // Skip the next iframe since it's already handled
            i++;
        }
    }
}

export {
	linksCustomization,
	scrollTo,
	responsiveTables,
	notificationPopup,
	smoothScrolling,
	lenis,
	textEditorDetectIframesTogether
};
